export const ROUTES = {
  LOGIN: '/login',
  REGISTER: '/signup',
  HOMEPAGE: '/',
  CATELOG: '/manage-catelog',
  PAID_SERVICE: '/paid_service_plans',
  SUBSCRIPTION: '/subscription',
  BBS: '/keyword-mapping',
  BUY_LEAD: '/buy_leads',
  MANAGE_LEADS: '/manage-leads',
  MANAGE_LEADS_DETAILS: '/manage-leads-details/:id',
  FORGOTPASSWORD: '/forgotpassword',
  RESET_PASSWORD: '/forgot_password',
  CATELOG_VIEWS: '/catelog-views',
  PHOTOS_DOCS: '/video-tutorial',
  CONTACT: '/support',
  SETTINGS: '/settings',
};
